// extracted by mini-css-extract-plugin
export default {"watchlistTableContainer":"WatchlistTable_watchlistTableContainer__ETUTe","alreadyExistsError":"WatchlistTable_alreadyExistsError__hCz0Q"};